/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MarketRegisterScannerIcon16Light } from './MarketRegisterScannerIcon16Light';
import { MarketRegisterScannerIcon16Regular } from './MarketRegisterScannerIcon16Regular';
import { MarketRegisterScannerIcon16Solid } from './MarketRegisterScannerIcon16Solid';
import { MarketRegisterScannerIcon20Light } from './MarketRegisterScannerIcon20Light';
import { MarketRegisterScannerIcon20Regular } from './MarketRegisterScannerIcon20Regular';
import { MarketRegisterScannerIcon20Solid } from './MarketRegisterScannerIcon20Solid';
import { MarketRegisterScannerIcon24Regular } from './MarketRegisterScannerIcon24Regular';
import { MarketRegisterScannerIcon24Solid } from './MarketRegisterScannerIcon24Solid';
import { MarketRegisterScannerIcon32Regular } from './MarketRegisterScannerIcon32Regular';
import { MarketRegisterScannerIcon64Regular } from './MarketRegisterScannerIcon64Regular';
var sizes = {
    16: {
        light: MarketRegisterScannerIcon16Light,
        regular: MarketRegisterScannerIcon16Regular,
        solid: MarketRegisterScannerIcon16Solid,
    },
    20: {
        light: MarketRegisterScannerIcon20Light,
        regular: MarketRegisterScannerIcon20Regular,
        solid: MarketRegisterScannerIcon20Solid,
    },
    24: {
        regular: MarketRegisterScannerIcon24Regular,
        solid: MarketRegisterScannerIcon24Solid,
    },
    32: {
        regular: MarketRegisterScannerIcon32Regular,
    },
    64: {
        regular: MarketRegisterScannerIcon64Regular,
    },
};
export var MarketRegisterScannerIcon = forwardRef('MarketRegisterScannerIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
